import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import { usePageHeader } from '../../providers/PageHeaderProvider';
import { NotificationPatientView } from '../../components/monitoring/notifications/view/NotificationPatientView';

export function MonitoringNotificationView() {
    usePageTitle('Monitoring · Notifications');
    const { setTitle, setSubtitle } = usePageHeader();
    const { patientId = '' } = useParams<{ patientId: string }>();

    useEffect(() => {
        setTitle('Notifications');
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [setTitle, setSubtitle]);

    // Keyed by patient: Prev/Next start fresh (tab, review animations, remembered neighbours).
    return (
        <div className="flex h-full flex-col overflow-hidden bg-gray-100">
            <NotificationPatientView key={patientId} patientId={patientId} />
        </div>
    );
}
